import React from 'react'
import styled from '@emotion/styled/macro'

const Button = styled('span')`
  color: white;
  background: #c7d3e3;
  border-radius: 6px;
  border: 1px solid #ededed;
  padding: 0 2px;
`

const You = () => {
  return <Button>You</Button>
}

export default You
